import React, { FC, ReactNode, useEffect } from 'react';
import { useConfigStore } from '../store/config';
import { useConfig } from '../hooks/useConfig';

const ConfigProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { loaded, error } = useConfigStore();
  const { loadConfig } = useConfig();

  useEffect(() => {
    if (loaded) {
      return;
    }
    void loadConfig();
  }, [loaded, loadConfig, error]);

  if (!loaded) {
    return null;
  }

  if (error) {
    return (
      <>
        <p className="text-sm font-bold text-red-500">
          Unable to load configuration
        </p>
        <p className="text-base font-semibold leading-6">{error.message}</p>
      </>
    );
  }

  return <>{children}</>;
};

export { ConfigProvider };
